import { __ } from "@wordpress/i18n";
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../layouts/withForm';
const RecommendationsRss = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    return (
        <>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("RSS Feed", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Includes policies you can apply to the RSS feed of your site.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">

                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/Disable based on requirement.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Disable RSS Feed", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.disable_rss_feed"
                                    checked={settingData?.security?.recommendations?.disable_rss_feed} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Remove RSS Feed Links", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Remove RSS Feed Links", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.remove_rss_feed_links"
                                    checked={settingData?.security?.recommendations?.remove_rss_feed_links} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">                                    
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Add Feature Image To RSS Feed", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Add Feature Image To RSS Feed", "ultimate-security")}</h6>
                                </div>
                            </div>                                    
                            <div className="col-auto">
                                <Switch 
                                    name="security.recommendations.add_feature_image_to_rss_feed"
                                    checked={settingData?.security?.recommendations?.add_feature_image_to_rss_feed} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(RecommendationsRss, 'security.recommendations');